import { io } from 'socket.io-client';

let socket = null;

export const initSocketClient = (token) => {
  if (socket) {
    socket.disconnect();
  }
  
  if (!token) return null;

  const baseUrl = (import.meta.env.VITE_API_URL || '').replace(/\/api$/, '') || '/';
  
  socket = io(baseUrl, {
    path: '/socket.io/',
    auth: { token },
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 2000,
    transports: ['websocket', 'polling'],
  });

  socket.on('connect', () => {
    console.log('[WS] Connected to backend');
  });

  socket.on('disconnect', () => {
    console.log('[WS] Disconnected from backend');
  });

  return socket;
};

export const getSocket = () => socket;
